import styled from "styled-components";
import { H3 } from "@/lib/styles/text";
import { bigLabelTypographicStyle } from "@/lib/styles/helpers";

export const Container = styled.div`
  position: relative;
  padding-top: 4.5rem;
`;

export const Heading = styled.div`
  position: relative;
`;

export const Title = styled(H3)`
  text-transform: uppercase;
  font-weight: 700;
  text-align: center;
  line-height: 1.5rem;
  width: 100%;
  padding: 1.5rem 0;
  background-color: ${({theme})=> theme.colors.white};
  ${bigLabelTypographicStyle}
`;

export const RelatedWrapper = styled.div`
  position: relative;
`;
